export enum BeneficiaryType {
  POPULATION = 'population',
  LOCAL_COMMUNITIES = 'local_communities',
  COMMUNITIES_OF_COMMUNES = 'communities_of_communes',
  REGIONS = 'regions',
  LOCAL_INSTITUTIONS = 'local_institutions',
  ASSOCIATIONS_NGOS = 'associations_ngos',
  OTHERS = 'others',
}
